import React from 'react'
import { Text } from "@nextui-org/react";
import SettingsForms from './settingsForms';

function Settings() {
  return (
    <div>
      <Text>
        Account Settings
      </Text>
      
      <SettingsForms />
    </div>
  )
}

export default Settings